import { useQuery } from "@tanstack/react-query";
import { api, unwrap } from "@/lib/api";
import { qk } from "@/lib/query-client";
import type { ApiEnvelope, PaymentRecord } from "@/lib/api-types";

/**
 * GET /payments/me -> PaymentRecord[] (newest first, signature redacted).
 *
 * The payments handler returns the array directly under `data`, so we unwrap
 * and fall back to an empty list. Cached 60s -- payment history changes only
 * when a new subscription is purchased.
 */
export function usePayments() {
  return useQuery({
    queryKey: qk.payments.mine(),
    queryFn: async () => {
      const res = await api.get<ApiEnvelope<PaymentRecord[]>>("/payments/me");
      return unwrap(res.data) ?? [];
    },
    staleTime: 60 * 1000,
  });
}
